import React, { Fragment } from 'react';
import { string } from 'prop-types';
import classnames from 'classnames';
import { Icons } from 'components';
import { fullStar, halfStar, emptyStar } from './utils';
import './Star.scss';

export default function Star({ className, starType }) {
    const rootClassnames = classnames('star', className);
    return (
        <Fragment>
            {starType === fullStar && <Icons.Star className={rootClassnames} />}
            {starType === halfStar && (
                <Icons.StarHalf className={rootClassnames} />
            )}
            {starType === emptyStar && (
                <Icons.StarOutline className={rootClassnames} />
            )}
        </Fragment>
    );
}

Star.propTypes = {
    starType: string,
    className: string,
};

Star.defaultProps = {
    starType: fullStar,
    className: null,
};
